import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import handleOpenWhatsApp from 'services/whatsappService';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const AreYouReady = () => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box marginTop={4} marginBottom={2} textAlign="center">
      <Typography variant="h5" sx={{ fontWeight: 700, color: h, mb: 2, fontFamily: 'Georgia, serif' }}>
        Coordinemos la alianza Colegio de Abogados × Legalmente en Familia
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ maxWidth: 560, mx: 'auto', mb: 3 }}>
        Programa ancla: <strong>Legalmente en Familia</strong> — lunes 12:00 PM en TNO Network. Hablar con comercial TNO
        para ajustar alcance y calendario con la junta directiva.
      </Typography>
      <Button variant="contained" color="primary" size="large" onClick={handleOpenWhatsApp}>
        Escribir por WhatsApp
      </Button>
      <Box marginTop={4}>
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
